// import { Details } from "@mui/icons-material";
import store from "../configureStore";
import { LANG } from "../types/enums";


export enum fields {
    NO_ACCESS = 'NO_ACCESS',
    SEARCH = 'SEARCH',
    RECENT = 'RECENT',
    FAVORITES= 'FAVORITES',
    ACTIVITIES= 'ACTIVITIES',
    COUNT= 'COUNT',
    OPEN_ACTIVITIES= 'OPEN_ACTIVITIES',
    CLOSED_ACTIVITIES= 'CLOSED_ACTIVITIES',
    DETAILS= 'DETAILS',
    DETAILS_LOWCASE = 'DETAILS_LOWCASE',
    FILES= 'FILES',
    COMMENTS= 'COMMENTS',
    START_FLYT= 'START_FLYT',
    ADD_COMMENT= 'ADD_COMMENT',
    CLOSE_ACTIVITY= 'CLOSE_ACTIVITY',
    DOCUMENTS= 'DOCUMENTS',
    COMMENT_LIST_COMMENT = 'COMMENT_LIST_COMMENT',
    COMMENT_LIST_BY = 'COMMENT_LIST_BY',
    COMMENT_LIST_CREATED = 'COMMENT_LIST_CREATED',
    COMMENT_LIST_ACTIVITY = 'COMMENT_LIST_ACTIVITY',
    COMMENT_LIST_DOC_ID = 'COMMENT_LIST_DOC_ID',
    COMMENT_LIST_REV_ID = 'COMMENT_LIST_REV_ID',
    RECEIVED = 'RECEIVED',
    DUE = 'DUE',
    DECISION = 'DECISION',
    ACTIVITY_DOCUMENTS = 'ACTIVITY_DOCUMENTS',
    ACTIVITY_COMMENTS = 'ACTIVITY_COMMENTS',
    DOCUMENT_COMMENT = 'DOCUMENT_COMMENT',
    ACTIVITY_DOCUMENT = 'ACTIVITY_DOCUMENT',
    ACTIVITY_COMMENT = 'ACTIVITY_COMMENT',
    ADD = 'ADD',
    ACTIVITY_ACTIVITY = 'ACTIVITY_ACTIVITY',
    ACTIVITY_CLOSE = 'ACTIVITY_CLOSE',
    ACTIVITY_CLOSED_ON = 'ACTIVITY_CLOSED_ON',
    NO_FILES = 'NO_FILES',
    USE_PREVIOUS_REV_FILES = 'USE_PREVIOUS_REV_FILES',
    ATTACH_TO_COMMENT = 'ATTACH_TO_COMMENT',
    TAKE_NEW_PICTURE = 'TAKE_NEW_PICTURE',
    TAKE_PICTURE = 'TAKE_PICTURE',
    CHANGE_CAM_MODE = 'CHANGE_CAM_MODE',
    FILER = 'FILER',
    SEND_REVISION = 'SEND_REVISION',
    ON_WF = 'ON_WF',
    MAIN_TITLE = 'MAIN_TITLE',
    WORKFLOW_DESC = 'WORKFLOW_DESC',
    WORKFLOW_NOTES = 'WORKFLOW_NOTES',
    WORKFLOW_NOTES_ERTMS = 'WORKFLOW_NOTES_ERTMS',
    DOK_KAT = 'DOK_KAT',
    FAG_KODE = 'FAG_KODE',
    DOK_TYPE = 'DOK_TYPE',
    STATUS = 'STATUS',
    STATDATE = 'STATDATE',
    BAN_BANE = 'BAN_BANE', 
    BAN_BANESTREKNING = 'BAN_BANESTREKNING',
    BAN_DELSTREKNING = 'BAN_DELSTREKNING',
}


export function mapFieldToText(field:fields):string {
    let translation:string;
    let lang = store.getState().uiItems.language;
     switch (field) {
            case fields.NO_ACCESS:                         
                translation = lang === LANG.ENG ? "You do not have required permission in Proarc to use this app, contatct Proarc administrator." : "Du har ikke nødvendige rettigheter til å bruke appen. Ta kontakt med Proarc administrator."              
                break; 
            case fields.MAIN_TITLE:                         
                translation = lang === LANG.ENG ? "Search, view and annotate documents in Proarc." : "Søk, se og kommenter på dokumenter i Proarc."              
                break; 
            case fields.SEARCH:                         
                translation = lang === LANG.ENG ? "Search" : "Søk"              
                break; 
            case fields.RECENT:                         
                translation = lang === LANG.ENG ? "Recent" : "Nylige"           
                break; 
            case fields.FAVORITES:                         
                translation = lang === LANG.ENG ? "Favorites" : "Favoritter"      
                break; 
            case fields.ACTIVITIES:                        
                translation = lang === LANG.ENG ? "Activities" : "Aktiviteter"           
                break; 
            case fields.COUNT:                         
                translation = lang === LANG.ENG ? "Count" : "Antall"           
                break; 
            case fields.OPEN_ACTIVITIES:                         
                translation = lang === LANG.ENG ? "Open activities" : "Åpne aktiviteter"            
                break; 
            case fields.CLOSED_ACTIVITIES:                         
                translation = lang === LANG.ENG ? "Closed activities" : "Lukket aktiviteter"            
                break; 
            case fields.DETAILS:                         
                translation = lang === LANG.ENG ? "DETAILS" : "DETALJER"           
                break; 
            case fields.DETAILS_LOWCASE:                         
                translation = lang === LANG.ENG ? "Details" : "Detaljer"           
                break; 
            case fields.FILES:                         
                translation = lang === LANG.ENG ? "FILES" : "FILER"         
                break; 
            case fields.COMMENTS:                         
                translation = lang === LANG.ENG ? "COMMENTS" : "KOMMENTARER"              
                break; 
            case fields.START_FLYT:                         
                translation = lang === LANG.ENG ? "START WORKFLOW" : "START INNMELDINGS FLYT"           
                break; 
            case fields.ADD_COMMENT:                         
                translation = lang === LANG.ENG ? "ADD COMMENT" : "LEGG INN KOMMETAR"            
                break; 
            case fields.CLOSE_ACTIVITY:                         
                translation = lang === LANG.ENG ? "CLOSE ACTIVITY" : "LUKK AKTIVITET"          
                break; 
            case fields.DOCUMENTS:                     
                translation = lang === LANG.ENG ? "DOCUMENTS" : "DOKUMENTER"             
                break; 
            case fields.COMMENT_LIST_ACTIVITY:                     
                translation = lang === LANG.ENG ? "Activity" : "Aktivitet"             
                break; 
            case fields.COMMENT_LIST_BY:                     
                translation = lang === LANG.ENG ? "By" : "Av"             
                break; 
            case fields.COMMENT_LIST_COMMENT:                     
                translation = lang === LANG.ENG ? "Comment" : "Kommentar"             
                break; 
            case fields.COMMENT_LIST_CREATED:                     
                translation = lang === LANG.ENG ? "Created" : "Opprettet"             
                break; 
            case fields.COMMENT_LIST_DOC_ID:                     
                translation = lang === LANG.ENG ? "Doc.Id" : "Dok.Id"             
                break; 
            case fields.COMMENT_LIST_REV_ID:                     
                translation = lang === LANG.ENG ? "Rev.Id" : "Rev.Id"             
                break;
            case fields.DECISION:                     
                translation = lang === LANG.ENG ? "Decision" : "Beslutning"             
                break;
            case fields.DUE:                     
                translation = lang === LANG.ENG ? "Due" : "Pl.Avsluttet"             
                break;
            case fields.RECEIVED:                     
                translation = lang === LANG.ENG ? "Received" : "Mottat"             
                break;
            case fields.ACTIVITY_DOCUMENTS:                     
                translation = lang === LANG.ENG ? "Documents" : "Dokumenter"             
                break;
            case fields.ACTIVITY_COMMENTS:                     
                translation = lang === LANG.ENG ? "Comments" : "Kommentarer"             
                break;
            case fields.ACTIVITY_DOCUMENT:                     
                translation = lang === LANG.ENG ? "documents" : "dokument"             
                break;
            case fields.ACTIVITY_COMMENT:                     
                translation = lang === LANG.ENG ? "comment" : "kommentar"             
                break;
            case fields.DOCUMENT_COMMENT:                     
                translation = lang === LANG.ENG ? "doc. comment" : "dokumentkommentar"             
                break;
            case fields.ACTIVITY_ACTIVITY:                     
                translation = lang === LANG.ENG ? "activity" : "aktivitet"             
                break;
            case fields.ACTIVITY_CLOSE:                     
                translation = lang === LANG.ENG ? "Close activity" : "Lukk aktivitet"             
                break;
            case fields.ACTIVITY_CLOSED_ON:                     
                translation = lang === LANG.ENG ? "Closed on" : "Lukket på"             
                break;
            case fields.NO_FILES:                     
                translation = lang === LANG.ENG ? "No files on this revision" : "Ingen filer på revisjon"             
                break; 
            case fields.USE_PREVIOUS_REV_FILES:                     
                translation = lang === LANG.ENG ? "Use previous revision file as a comment file source" : "Brukk forige revijons filer for kommentering"             
                break;   
            case fields.ATTACH_TO_COMMENT:                     
                translation = lang === LANG.ENG ? "Attach to comment" : "Legg til kommentar"             
                break;  
            case fields.TAKE_NEW_PICTURE:                     
                translation = lang === LANG.ENG ? "Take a new picture" : "Ta ny bilde"             
                break;  
            case fields.TAKE_PICTURE:                     
                translation = lang === LANG.ENG ? "Take picture" : "Ta bilde"             
                break;  
            case fields.CHANGE_CAM_MODE:                     
                translation = lang === LANG.ENG ? "Change camera mode" : "Endre kamera modus"             
                break;                 
            case fields.FILER:                     
                translation = lang === LANG.ENG ? "Files" : "Filer"             
                break;                    
            case fields.ADD:                     
                translation = lang === LANG.ENG ? "Add" : "Legg til"             
                break;
            case fields.SEND_REVISION:                     
                translation = lang === LANG.ENG ? "Send revision" : "Send revisjon"             
                break;
            case fields.ON_WF:                     
                translation = lang === LANG.ENG ? "on workflow" : "på flyt"             
                break;
            case fields.WORKFLOW_DESC:                     
                translation = lang === LANG.ENG ? "Workflow description" : "Arbeidsflyt beskrivelse"             
                break;
            case fields.WORKFLOW_NOTES:                     
                translation = lang === LANG.ENG ? "Workflow notes" : "Dersom du ikke skal være \"Godkjenner\", oppgi korrekt navn under"
                break;
            case fields.WORKFLOW_NOTES_ERTMS:                     
                translation = lang === LANG.ENG ? "Workflow notes" : "Arbeidsflyt notater"
                break;
            case fields.DOK_KAT:                     
                translation = lang === LANG.ENG ? "Doc. category" : "Doc. kategori"
                break;
            case fields.FAG_KODE:                     
                            translation = lang === LANG.ENG ? "Fag" : "Fag"
                            break;
            case fields.DOK_TYPE:                     
                            translation = lang === LANG.ENG ? "Doc. type" : "Dokumenttype"
                            break;
            case fields.STATUS:                     
                translation = lang === LANG.ENG ? "Status" : "Status"
                break;
            case fields.STATDATE:                     
                translation = lang === LANG.ENG ? "Status date" : "Status dato"
                break;
            case fields.BAN_BANE:                     
                translation = lang === LANG.ENG ? "Bane" : "Bane"
                break;
            case fields.BAN_BANESTREKNING:                     
                translation = lang === LANG.ENG ? "Banestrekning" : "Banestrekning"
                break;
            case fields.BAN_DELSTREKNING:                     
                translation = lang === LANG.ENG ? "Banedelstrekning" : "Banedelstrekning"
                break;

            default:
                    translation = ""  
            } 
    return translation;
}
